import queryString from "query-string";

import { SIDELOADED_BUSINESS } from "constants/actionTypes";

import { URLCreatorProps } from "actions/types";
import { serializeSideLoadedBusiness } from "lib/serializers/sideLoadedBusinesses";
import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const sideLoadedDataUrlCreator = ({
  changesSince,
  id,
  action,
}: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/sideloaded-data/", id, action),
    query: {
      changesSince,
    },
  });

export const SideLoadedBusinessAction = offlineActionCreator(
  SIDELOADED_BUSINESS,
  serializeSideLoadedBusiness,
  sideLoadedDataUrlCreator,
  false,
);
